import { AvailableIcons } from '@sbt-web/banners';
import type { AdItem, InfoPromo } from '@sbt-web/network/types';
import { isShippable } from '@sbt-web/utils';
import type { HoustonBannerContent } from '@/shared/helpers/getHoustonBannerContent';

export const getSpecialCampaignBannerData = (
  ad: AdItem,
  isSold: boolean,
  promo?: InfoPromo | null,
  houstonBanner?: HoustonBannerContent | null
) => {
  if (isSold) {
    return;
  }

  const shippable = isShippable(ad);

  /*
   * Return a promotion data if it's active
   */
  if (shippable && promo?.content) {
    const title = promo.content?.title?.trim();
    const altSubtitle = promo.content?.countdown?.alternativeSubtitle?.trim();
    const subtitle = promo.content?.subtitle?.trim();
    const description = altSubtitle || subtitle;
    const iconName = promo.content?.assets?.resourceName as AvailableIcons;
    const externalIcon = promo.content?.assets?.resourceUrl;

    // Required props must be present
    if (title && description && iconName) {
      return {
        title,
        description,
        iconName,
        ...(!!altSubtitle && { countdownTo: promo.endDate }),
        ...(externalIcon && { alternativeExternalIconURL: externalIcon }),
      };
    }
  }

  /*
   * Othwerwise fallback to the banner managed by Houston
   */
  if (houstonBanner) {
    const title = houstonBanner?.bannerTitle?.trim();
    const description = houstonBanner?.bannerDescription?.trim();
    const requireShippable = !!houstonBanner?.showOnlyInShippableAds;

    if (title && description && (!requireShippable || shippable)) {
      return {
        title,
        description,
        iconName: 'Info' as AvailableIcons,
        alternativeExternalIconURL: `${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/logos/corporate-logo-small.svg`,
      };
    }
  }

  return null;
};
